import { DISPOSAL_PURPOSE } from '@schuettflix/interfaces';

export const DISPOSAL_PURPOSE_LABEL_NAME = {
    RECYCLING: 'product.productCharacteristics.disposalPurpose.recycling.label',
    DISPOSAL: 'product.productCharacteristics.disposalPurpose.disposal.label',
} as const satisfies Record<DISPOSAL_PURPOSE, string>;

export const DISPOSAL_PURPOSE_DESCRIPTION = {
    RECYCLING: 'product.productCharacteristics.disposalPurpose.recycling.description',
    DISPOSAL: 'product.productCharacteristics.disposalPurpose.disposal.description',
} as const satisfies Record<DISPOSAL_PURPOSE, string>;
